<template>
  <div class="contents">
    <div class="content_map jobModule">
      <el-container style="flex-direction: column;">
        <MachineryNav></MachineryNav>
        <div class="maps">
          <div class="Gogle-map">
            <div class="select-block">
              <div class="mapBox">
                <div id="container" class="myMaps">
                  <div id="mapMain" style="width: 100%; height: 100%"></div>
                  <div class="mapAllText">
                    <ul class="njClass1">
                      <li
                        v-for="(item, index) in tabArr"
                        :class="{ active: isActive == index }"
                        @click="tabClick(item,index)"
                        :key="index"
                      >
                        {{ item.name }}<br />
                        <span v-if="item.num">{{ item.num }}</span>
                        <span v-else>0</span> 台
                      </li>
                    </ul>
                    <ul class="areaText" v-if="this.$store.state.Code === '11'">
                      <li>
                        <el-select
                          v-model="countryCode"
                          placeholder="请选择区"
                          clearable
                        >
                          <el-option
                            v-for="item in cityOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @click.native="getCountry(item)"
                            >{{ item.label }}
                          </el-option>
                        </el-select>
                        <el-select
                          v-model="townCode"
                          placeholder="请选择镇"
                          clearable
                        >
                          <el-option
                            v-for="item in townsList"
                            :key="item.townCode"
                            :label="item.townName"
                            :value="item.townCode"
                            @click.native="changeTowns(item)"
                            >{{ item.townName }}
                          </el-option>
                        </el-select>
                        <el-button
                          type="primary"
                          icon="el-icon-search"
                          @click="handleSearch"
                          >查询</el-button
                        >
                      </li>
                      <li v-show="searchTotal">
                        <p v-if="isActive == 0">{{ tabArr[0].name }}</p>
                        <p v-else>{{ tabArr[isActive].name }}总数</p>
                        <b v-if="isActive == 0"
                          >{{ allTotalNum }}<span> 台</span></b
                        >
                        <b v-else-if="isActive == 1"
                          >{{ allTotal1 }}<span> 台</span></b
                        >
                        <b v-else-if="isActive == 2"
                          >{{ allTotal2 }}<span> 台</span></b
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="dialogMapDetail" class="dialogMapDetail myDialog">
              <div class="dialogWrap">
                <div class="dialogTitle">
                  {{ this.dataTitle.njName }}作业信息
                </div>
                <div class="dialogClose" @click="dialogMapDetailClick">×</div>
                <TrackLayer
                  ref="trackLayer"
                  :imei="imei"
                  :collectTime="collectTime"
                  :id="njId"
                  :statusStatic="statusStatic"
                ></TrackLayer>
              </div>
            </div>
          </div>
        </div>
        <div class="historyDialog myDialog" v-show="historyDialog">
          <div class="dialogWrap">
            <div class="dialogClose" @click="dialogMapDetailClick">×</div>
            <NonceDetailsDialog :imei="imei" :id="njId"></NonceDetailsDialog>
          </div>
        </div>
      </el-container>
    </div>
  </div>
</template>
<script>
import "echarts/map/js/china.js";
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
import MachineryNav from "./MachineryNav.vue";

import "maptalks/dist/maptalks.css";
import * as maptalks from "maptalks";
import { HeatLayer } from "maptalks.heatmap";
import TalksMap from "../../map/js/initMapTalks旧.js";
import NonceDetailsDialog from "./NonceDetailsDialog.vue";
import TrackLayer from "./nonceTrackLayer.vue";

export default {
  name: "Monitor",
  components: {
    MachineryNav,
    NonceDetailsDialog,
    TrackLayer
  },
  data() {
    return {
      allLayer: "",
      mapPolygon: [],
      allPolygon: [],
      njInfo: {},

      list: [],
      markers: "", //聚合物
      listtexs: "",
      dialogMapDetail: false,
      dialogMapDetailValue: "",
      dataTitle: "",
      cityOptions: [],
      defaultPinmu: "1",
      year: "",
      yearVal: new Date().getFullYear(),
      yearShowOne: false,
      countryCode: "",
      townCode: "",
      yeardata: [],
      area: "11864.67",
      total: "237",
      activeVal: "耕地作业",
      blockIdLoaded: [],
      defaultYear: new Date().getFullYear(),
      zoomEnd: "",
      townsList: [],
      cityVal: "",
      townVal: "",
      TalksMap: new TalksMap(),
      defaultTime: [],
      timeVal: [],
      blockIds: [],
      showLine: false,
      showLineVal: false,
      testJsonArr: [],
      total: [0, 0, 0, 0],
      timeList: [9, 13, 17],
      dialogMapDetail: false,
      dataTitleShow: true,
      runTimeDay: "",
      operatArea: "",
      currentDate: "",
      tabArr: [
        {
          name: "机具总数",
          val: "",
          num: 0
        },
        {
          name: "拖拉机",
          val: 1,
          num: 0
        },
        {
          name: "收获机",
          val: 2,
          num: 0
        }
      ],
      workType: "",
      isActive: 0,
      cityName: this.$store.state.areaName === "全国" ? "全国" : "本省",
      pointData1: [],
      pointData2: [],
      pointData5: [],
      allPointsData: [],
      setMarkersData: [],
      historyDialog: false,
      workDialog: false,
      imei: "",
      njId: "",
      collectTime: "",
      currentdateText: "",
      townsList: [],
      cityCode: "",
      countryCode: "",
      allTotal: 0,
      searchTotal: false,
      calendarFlag: false,
      startContinue: "start",
      operationForPauseAndContinue: "pause",
      map: "",
      stopedIndex: 0,
      trackList: [],
      getGjTime: "",
      requestTimer: null,
      lastRequestData: [],
      statusStatic: true,
      allTotalNum: 0,
      allTotal1: 0,
      allTotal2: 0,
      countryName: "",
      infoMsg: {}
      // workTypeData_1: [],
      // workTypeData_2: []
    };
  },
  created() {
    let _this = this;
    if (this.$store.state.Code === "11") {
      this.getcity();
      this.getTownsList(this.$store.state.Code);
    }
    window.viewHistory = _this.viewHistory;
    window.viewCurrentLine = _this.viewCurrentLine;
  },
  mounted() {
    let this_ = this;
    this.currentDate = this.getNowFormatDates();
    this.collectTimeEnd = this.getNowFormatDates() + " 23:59:59";
    this.$nextTick(() => {
      this.initMapTalk();
    });
    document.addEventListener("click", function(e) {
      if (this_.popVisible === true) {
        this_.popVisible = false;
      }
    });
  },
  methods: {
    // 县（区）查询
    getcity(value) {
      var parmse = {};
      var url = Http.test + "/area/getCountyOfProvinceForMunicipality";
      Api.doPost(url, { provCode: this.$store.state.Code }, false, res => {
        this.cityOptions = res.result;
        this.cityOptions.unshift(shanghai);
      });
    },
    // 县（区）选择
    getCountry(item) {
      this.countryName = item.label;
      if (item.value && item.value !== "0") {
        this.countryCode = item.value;
        this.getTownsList(item.value);
      } else {
        this.countryCode = "";
      }
    },
    // 乡镇列表
    getTownsList(value) {
      Api.doPost(
        Http.area.townsList,
        {
          countyCode: value
        },
        false,
        res => {
          this.townsList = res.result;
        }
      );
    },
    changeTowns(item) {
      if (item.townCode) {
        this.townCode = item.townCode;
      } else {
        this.townCode = "";
      }
    },
    handleSearch() {
      this.getHeatLayer();
      this.searchTotal = this.countryName ? true : false;
    },
    // 农机分类tab切换
    tabClick(item, index) {
      this.isActive = index;
      this.TalksMap.mapDom.setZoom(4);
      let data = [];
      if (index == 0) {
        data = this.allData;
      } else if (index == 1) {
        data = this.workTypeData_1;
      } else if (index == 2) {
        data = this.workTypeData_2;
      }

      this.allTotalNum = item.num;
      this.allTotal1 = item.num;
      this.allTotal2 = item.num;

      // this.getHeatLayer();
      this.allPointLayer.clear();
      this.allHeatLayer.clear();
      this.allHeatLayer.setData(data);
    },
    // 获取当前月
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      this.currentdateText = year + "年" + month + "月" + strDate + "日";

      return currentdate;
    },
    //初始化地图
    initMapTalk() {
      let this_ = this;
      this.TalksMap.init("mapMain");

      this.allPointLayer = new maptalks.VectorLayer("point").addTo(
        this.TalksMap.mapDom
      );
      this.allHeatLayer = new HeatLayer("heat").addTo(this.TalksMap.mapDom);

      let noZoomLevel = new maptalks.control.Zoom({
        position: {
          bottom: 10,
          right: 10
        },
        slider: true,
        zoomLevel: true
      });
      this.TalksMap.mapDom.addControl(noZoomLevel);
      this.TalksMap.mapDom.setMinZoom(4);
      this.TalksMap.mapDom.setZoom(4);

      let Coordinate = {
        x: 106.019973,
        y: 38.671199
      };
      this.TalksMap.mapDom.setCenter(Coordinate);

      //  级别变化事件
      this.TalksMap.mapDom.on("zoomend", function(e) {
        this_.zoomEnd = e.to;
        if (e.to >= 11) {
          //级别大于12加载地块
          if (this_.allPointLayer.getCount() == 0) {
            let data = this_.TalksMap.mapDom.getExtent();
            this_.getMarkers(data);
          }
        }
        if (e.to < 11 && this_.allHeatLayer.getData().length > 0) {
          //级别小于16删除地块
          this_.allHeatLayer.show();
          this_.allPointLayer.clear();
        }
      });
      //  移动地图事件
      this.TalksMap.mapDom.on("movestart", function(e) {
        this.startPoint = e.containerPoint || e.target.startPoint;
      });
      this.TalksMap.mapDom.on("moveend", function(e) {
        //移动地图结束，计算移动到一定距离加载地块
        this.endPoint = e.containerPoint || e.target.endPoint;
        var a = this.endPoint.x - this.startPoint.x;
        var b = this.endPoint.y - this.startPoint.y;

        var c = Math.sqrt(a * a + b * b);

        if (c > 300 && this_.zoomEnd >= 11) {
          let data = this_.TalksMap.mapDom.getExtent();
          this_.getMarkers(data);
        }
      });
      this.getHeatLayer();
    },
    // 获取markers数据
    getMarkers(data) {
      var this_ = this;
      var params = {
        xmin: data.xmin,
        ymin: data.ymin,
        xmax: data.xmax,
        ymax: data.ymax,
        ymax: data.ymax,
        countyCode: this.countryCode
      };
      Api.doPost(Http.gis.getHeatmapDataByExtendBeijing, params, false, res => {
        this_.allHeatLayer.hide(); //隐藏热力图
        this.pointData1 = res.result.worktype_46
          ? res.result.worktype_46.map(function(data) {
              data.vdata.push(data.imei);
              data.vdata.push("拖拉机");
              data.vdata.push(data.status); //当前状态
              data.vdata.push(data.currentLocation); //当前位置
              data.vdata.push(data.collectTime); //采集时间
              data.vdata.push(data.factoryCode); //出厂编号
              data.vdata.push(data.ownerName); //农机主
              data.vdata.push(data.njName); //农机类型
              data.vdata.push(data.njId);
              data.vdata.push(data.productModel);
              return data.vdata;
            })
          : [];
        this.pointData2 = res.result.worktype_47
          ? res.result.worktype_47.map(function(data) {
              data.vdata.push(data.imei);
              data.vdata.push("收获机");
              data.vdata.push(data.status);
              data.vdata.push(data.currentLocation); //当前位置
              data.vdata.push(data.collectTime); //采集时间
              data.vdata.push(data.factoryCode); //出厂编号
              data.vdata.push(data.ownerName); //农机主
              data.vdata.push(data.njName); //农机类型
              data.vdata.push(data.njId);
              data.vdata.push(data.productModel);
              return data.vdata;
            })
          : [];

        this.allPointsData = this.pointData1.concat(this.pointData2);
        if (this.isActive == 0) {
          this.setMarkersData = this.allPointsData;
        } else if (this.isActive == 1) {
          this.setMarkersData = this.pointData1;
        } else if (this.isActive == 2) {
          this.setMarkersData = this.pointData2;
        }
        this.setMarkers();
      });
    },
    setMarkers() {
      let this_ = this;
      this.allHeatLayer.hide(); //隐藏热力图
      this.setMarkersData.forEach(function(item, index) {
        let imgUrl;
        if (item[5] == 1) {
          //运动
          if (item[4] == "拖拉机") {
            //拖拉机
            imgUrl = require("../../assets/img/mapIcon1_on.png");
          } else if (item[4] == "收获机") {
            //收获机
            imgUrl = require("../../assets/img/mapIcon5_on.png");
          }
        } else {
          if (item[4] == "拖拉机") {
            //拖拉机
            imgUrl = require("../../assets/img/mapIcon1.png");
          } else if (item[4] == "收获机") {
            //收获机
            imgUrl = require("../../assets/img/mapIcon5.png");
          }
        }

        var point = new maptalks.Marker(item, {
          visible: true,
          editable: true,
          cursor: "pointer",
          shadowBlur: 0,
          shadowColor: "black",
          draggable: false,
          dragShadow: false, // display a shadow during dragging
          drawOnAxis: null, // force dragging stick on a axis, can be: x, y
          symbol: [
            {
              markerFile: imgUrl,
              markerWidth: 30,
              markerHeight: 40,
              markerDx: 0,
              markerDy: 0,
              markerOpacity: 1
            }
          ],
           properties:{
          	id:item[3],
            obj:item[4],
            detail: item
          }
        });
        point.on("click", this_.displayInfoWindow);
        point.addTo(this_.allPointLayer);
      });
    },
    // 更新实时位置信息接口
    updateCurrentLocation (imei) {
      Api.doPost(
        Http.gis.updateCurrentLocation,
        {
          type: 'gps',
          imei: imei,
          lat: 0,
          lng: 0
        },
        false,
        res => {
          // console.log(res)
        })
    },
    // 显示信息窗口
    displayInfoWindow(e) {
      let this_ = this;
      let targetPolygon = e.target;
      let markerDetail = targetPolygon.getProperties()
      let id = targetPolygon.getProperties().id; //监控编号
      this.updateCurrentLocation(id)
      if (targetPolygon.getInfoWindow()) {
        targetPolygon.openInfoWindow();
      } else {
        let blockInfo = targetPolygon.properties;
        targetPolygon.updateSymbol({
          lineColor: "blue"
        });
        var content = [];
        // for (var j = 0; j < this.setMarkersData.length; j++) {
          // if (this.setMarkersData[j][3] === id) {
            // var info = this.setMarkersData[j];
            var info = targetPolygon.getProperties().detail
            let collectTimes = info[7];
            this.imei = id;
            this.njId = info[11];
            if (collectTimes) {
              this.collectTime = collectTimes.slice(0, 10);
            } else {
              this.collectTime = "";
            }
            this.njStatus = info[5];
            let statusName = info[5] == 1 ? "运动" : "静止";
            this.dataTitle = {
              imei: id,
              productModel: info[12],
              factoryCode: info[8],
              operatTime: this.collectTime,
              workArea: info[6],
              njName: info[10]
            };
            if (targetPolygon.getProperties() == "其他") {
              if (this.collectTime == this.getNowFormatDates()) {
                content = [
                  '<div style=" font-size:11px; width: 330px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
                  "<li>监控编号：",
                  id,
                  "</li>",
                  "<li>采集时间：",
                  this.collectTime,
                  "</li>",
                  "<li>当前状态：",
                  statusName,
                  "</li>",
                  "<li>当前位置：",
                  info[6],
                  "</li></ul>",
                  '<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
                  '<button class="Cancel viewMoreDialog" onclick="viewCurrentLine()">当日轨迹</button>',
                  "</div>"
                ];
              } else {
                content = [
                  '<div style=" font-size:11px; width: 330px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
                  "<li>监控编号：",
                  id,
                  "</li>",
                  "<li>采集时间：",
                  this.collectTime,
                  "</li>",
                  "<li>当前状态：",
                  statusName,
                  "</li>",
                  "<li>当前位置：",
                  info[6],
                  "</li></ul>",
                  '<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
                  '<button class="Cancel" style="display:none"></button>',
                  "</div>"
                ];
              }
            } else {
              if (this.collectTime == this.getNowFormatDates()) {
                content = [
                  '<div style=" font-size:11px; width: 330px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
                  "<li>农机类型：",
                  info[10],
                  "</li>",
                  "<li>农机主：",
                  info[9],
                  "</li>",
                  "<li>出厂编号：",
                  info[8],
                  "</li>",
                  "<li>监控编号：",
                  id,
                  "</li>",
                  "<li>采集时间：",
                  this.collectTime,
                  "</li>",
                  "<li>当前状态：",
                  statusName,
                  "</li>",
                  "<li>当前位置：",
                  info[6],
                  "</li></ul>",
                  '<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
                  '<button class="Cancel viewMoreDialog" onclick="viewCurrentLine()">当日轨迹</button>',
                  "</div>"
                ];
              } else {
                content = [
                  '<div style=" font-size:11px; width: 330px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
                  "<li>农机类型：",
                  info[10],
                  "</li>",
                  "<li>农机主：",
                  info[9],
                  "</li>",
                  "<li>出厂编号：",
                  info[8],
                  "</li>",
                  "<li>监控编号：",
                  id,
                  "</li>",
                  "<li>采集时间：",
                  this.collectTime,
                  "</li>",
                  "<li>当前状态：",
                  statusName,
                  "</li>",
                  "<li>当前位置：",
                  info[6],
                  "</li></ul>",
                  '<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
                  '<button class="Cancel" style="display:none"></button>',
                  "</div>"
                ];
              }
            }
            var options = {
              single: true,
              width: 383,
              height: 405,
              custom: false,
              dx: 0,
              dy: 0,
              autoPan: false,
              eventsPropagation: true,
              title: "农机信息",
              content: content.join("")
            };
            targetPolygon.setInfoWindow(options);
            targetPolygon.openInfoWindow();
          // }
        // }
      }
      this.TalksMap.mapDom.panTo(e.coordinate);
    },
    viewHistory() {
      this.historyDialog = true;
    },
    // 查看当天
    viewCurrentLine() {
      let this_ = this;
      this.dialogMapDetail = true;
      this.$refs.trackLayer.getGjTime = "";
      this.$refs.trackLayer.getCenterPos();
      this.$refs.trackLayer.dataTitle = this.dataTitle;
      this.$nextTick(function() {
        if (this.njStatus == 0) {
          this.statusStatic = true;
          this.$refs.trackLayer.trackViewing(); //当天静止状态 (历史)
        } else {
          this.statusStatic = false;
          this.$refs.trackLayer.trackMove(true); //当天运动状态 (实时)
          // 定时器增量加载实时数据
          this.requestTimer = setInterval(() => {
            this_.$refs.trackLayer.trackMove(false);
          }, 10000);
        }
      });
    },
    // 获取热力图数据
    getHeatLayer() {
      var this_ = this;
      this.workTypeData_1 = [];
      this.workTypeData_2 = [];
      this.allData = [];
      var parmse = {
        countyCode: this.$store.state.Code === "11" ? this.countryCode : this.$store.state.Code,
        townCode: this.$store.state.Code === "11" ? this.townCode : undefined
      }
      Api.doPost(Http.gis.getHeatmapDataBeijing, parmse, false, res => {
        if (res.result.worktype_1 !== undefined && res.result.worktype_2 !== undefined) {
          this.allTotalNum = res.result.worktype_1_num + res.result.worktype_2_num;
          this.allTotal1 = res.result.worktype_1_num;
          this.allTotal2 = res.result.worktype_2_num;
          this.workTypeData_1 = res.result.worktype_1;
          this.workTypeData_2 = res.result.worktype_2;
          this.allData = this.workTypeData_1.concat(this.workTypeData_2);
          this.tabArr = [
            {
              name: "机具总数",
              val: "",
              num: this.allTotalNum
            },
            {
              name: "拖拉机",
              val: 1,
              num: this.allTotal1
            },
            {
              name: "收获机",
              val: 2,
              num: this.allTotal2
            }
          ];
        } else if (res.result.worktype_1 !== undefined) {
          this.allData = res.result.worktype_1;
          this.allTotalNum = res.result.worktype_1_num
          this.allTotal1 = res.result.worktype_1_num;
          this.tabArr = [
            {
              name: "机具总数",
              val: "",
              num: this.allTotalNum
            },
            {
              name: "拖拉机",
              val: 1,
              num: this.allTotal1
            },
            {
              name: "收获机",
              val: 2,
              num: 0
            }
          ];
        } else if (res.result.worktype_2 !== undefined) {
          this.allData = res.result.worktype_2;
          this.allTotalNum = res.result.worktype_2_num;
          this.allTotal2 = res.result.worktype_2_num;
          this.tabArr = [
            {
              name: "机具总数",
              val: "",
              num: this.allTotalNum
            },
            {
              name: "拖拉机",
              val: 1,
              num: 0
            },
            {
              name: "收获机",
              val: 2,
              num: this.allTotal2
            }
          ]
        } else {
          this.allTotalNum = 0;
          this.allTotal1 = 0;
          this.allTotal2 = 0;
          this.allData = [];
          this.tabArr = [
            {
              name: "机具总数",
              val: "",
              num: 0
            },
            {
              name: "拖拉机",
              val: 1,
              num: 0
            },
            {
              name: "收获机",
              val: 2,
              num: 0
            }
          ];
        }
        this.setHeatLayer();
      });
    },
    setHeatLayer() {
      this.allHeatLayer.clear();
      this.renderStart2 = new Date().getTime();
      this.allHeatLayer.setData(this.allData);
      let opt = {
        0.4: "blue",
        0.6: "cyan",
        0.9: "yellow",
        1.0: "red"
      };
      this.allHeatLayer.config({
        radius: 5,
        blur: 6,
        gradient: opt
      });
      var elapsed2 = new Date().getTime() - this.renderStart2;
      // console.log("热力图渲染时间" + elapsed2 + "ms");
    },
    dialogMapDetailClick() {
      let childLayer = this.$refs.trackLayer;
      let childLayerMap = this.$refs.trackLayer.TalksMapDialog;
      if (childLayerMap._timer || childLayerMap.i > 0) {
        clearInterval(childLayerMap._timer);
        childLayerMap.i = 0;
        childLayerMap._timer = "";
      }
      childLayerMap.lastLineLayer.clear();
      childLayerMap.carPoint.clear();
      childLayerMap.fist = true;
      childLayerMap.lineLog = [];
      childLayerMap.lastLinePoints = [];
      childLayerMap.btnName = "";
      childLayer.operationForPauseAndContinue = "start";
      document.getElementById("pauseBtns").innerHTML = "开始";
      childLayer.continueOrStopUrl = childLayer.kaishi;
      childLayer.calendarFlag = true;

      this.dialogMapDetail = false;
      this.historyDialog = false;

      if (this.requestTimer) {
        clearInterval(this.requestTimer);
        this.timer = null;
      }
    }
  }
};
</script>

<style scoped>
.njClass {
	/* z-index: 99;
	padding: 10px; */
	width: 12vw;
  /* background: rgba(0, 0, 0, 0.8); */
  height: 100%;
  float: left;
}
.njClass1 li  {
	font-size: 0.9vw;
	line-height: 3vh;
	cursor: pointer;
	color: #439bff;
	padding: 1.5vh 0;
	/*padding-left: 90px;*/
	padding-left: 4.9vw;
}

.njClass1 li span{
	font-size: 1.2vw;
}

.njClass1 li.active {
	color: #ffffff;
}

.njClass1 li:first-child {
  background: url(../../assets/img/njfb_all0.png) no-repeat 20% center;
  background-size: 2.1vw 2.1vw;
}

.njClass1 li:first-child.active {
  background: url(../../assets/img/njfb_all1.png) #04209c no-repeat 20% center;
  background-size: 2.1vw 2.1vw;
}

.njClass1 li:nth-child(2) {
  background: url(../../assets/img/njfb_tlj.png) no-repeat 19% center;
  background-size: 2.6vw 2.1vw;
}

.njClass1 li:nth-child(2).active {
  background: url(../../assets/img/njfb_tlj1.png) #04209c no-repeat 19% center;
  background-size: 2.6vw 2.1vw;
}
.njClass1 li:nth-child(3) {
  background: url(../../assets/img/njfb_shj0.png) no-repeat 17% center;
  background-size: 2.8vw 2.1vw;
}

.njClass1 li:nth-child(3).active {
  background: url(../../assets/img/njfb_shj1.png) #04209c no-repeat 17% center;
  background-size: 2.8vw 2.1vw;
}
/* .njClass1 li:nth-child(3) {
  background: url(../../assets/img/njfb_cyj01.png) no-repeat 17% center;
  background-size: 2.8vw 2.1vw;
}

.njClass1 li:nth-child(3).active {
  background: url(../../assets/img/njfb_cyj11.png) #04209c no-repeat 17% center;
  background-size: 2.8vw 2.1vw;
}

.njClass1 li:nth-child(4).active {
  background: url(../../assets/img/njfb_shj1.png) #04209c no-repeat 18% center;
  background-size: 2.6vw 2.1vw;
}

.njClass1 li:nth-child(4) {
  background: url(../../assets/img/njfb_shj0.png) no-repeat 18% center;
  background-size: 2.6vw 2.1vw;
}

.njClass1 li:nth-child(5) {
  background: url(../../assets/img/qita0.png) no-repeat 17% center;
  background-size: 2.3vw 2.1vw;
}

.njClass-m li:nth-child(5).active {
  background: url(../../assets/img/qita1.png) #04209c no-repeat 17% center;
  background-size: 2.3vw 2.1vw;
} */
.contents {
  width: 100%;
  /* height: 100%; */
  /* margin: 0 auto; */
}

.content_map {
  width: 98%;
  margin: 0 auto;
}

.maps {
  width: 100%;
  height: 79vh;
  /* background-image: url("/static/img/map.png"); */
  background-size: 100%;
  background-repeat: no-repeat;
  margin-top: 10px;
  margin-bottom: 10px;
}

.Gogle-map {
  height: 96%;
  width: 100%;
  margin-bottom: 15px;
  position: relative;
  z-index: revert;
  /* padding: 10px; */
}

#tools {
  height: 64px;
  width: 100%;
  background: rgba(10, 22, 55, 0.5);
  position: absolute;
  z-index: 999;
  bottom: 0;
}

.btns {
  width: 35%;
  margin: 0 auto;
  display: flex;
}

.btns dl {
  /* margin-right: 16%; */
  width: 20%;
  padding-top: 7px;
  padding-left: 8%;
}

.btns dl dt {
  width: 30px;
  height: 30px;
  border: solid 1px #fff;
  border-radius: 50%;
  margin: auto;
  cursor: pointer;
}

.btns dl:nth-child(1) dt img {
  width: 13px;
  height: 13px;
  margin-left: 8px;
  margin-top: 8px;
}

.btns dl:nth-child(2) dt img {
  width: 13px;
  height: 13px;
  margin-left: 8.5px;
  margin-top: 8px;
}

.btns dl:nth-child(3) dt img {
  width: 12px;
  height: 13px;
  margin-left: 10px;
  margin-top: 9px;
}

.btns dl:nth-child(4) dt img {
  width: 13px;
  height: 13px;
  margin-left: 8px;
  margin-top: 8px;
}

.btns dl:nth-child(5) dt img {
  width: 13px;
  height: 13px;
  margin-left: 10px;
  margin-top: 8px;
}

dd {
  text-align: center;
  color: #fff !important;
}

.items p {
  height: 40px;
  line-height: 18px;
  padding-left: 10px;
  color: #fff;
}

.items p span:nth-child(1) {
  width: 70px;
  display: inline-block;
  text-align: right;
}

.tableList1 {
  margin-top: 10px;
}

.img-onlyRead {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/MachineryStock.vue